import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { SignupComponent } from './common-singup/signup/signup.component';
import { RegistrationThankyouComponent } from './components/registration-thankyou/registration-thankyou.component';
import { SaudiabusinessLandingComponent } from './components/saudiabusiness-landing/saudiabusiness-landing.component';
import { RegistartionIntermediaryComponent } from './components/registartion-intermediary/registartion-intermediary.component';
import { FaqsComponent } from 'src/app/shared/components/faqs/faqs.component';
import { ValidateLoginComponent } from 'src/app/shared/components/validate-login/validate-login.component';
import { AdminInfoComponent } from './components/admin-info/admin-info.component';
import { AdminSignupComponent } from './common-singup/admin-signup/admin-signup.component';
import { GenerateTokenComponent } from './components/generate-token/generate-token.component';
import { DependentOnboardComponent } from './common-singup/dependent-onboard/dependent-onboard.component';
import { DependentTokenComponent } from './common-singup/dependent-token/dependent-token.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
         component: SaudiabusinessLandingComponent
      },
      {
        path: 'intermediate',
         component: RegistartionIntermediaryComponent
      },
      {
        path: 'Signup',
         component: SignupComponent
      },
      {
        path:'Thankyou',
        component:RegistrationThankyouComponent
      },
      {
        path:'Faq',
        component:FaqsComponent
      },
      // {
      //   path: 'validateLogin',
      //   component: ValidateLoginComponent
      // }, 
      {
        path: 'Signup',
        redirectTo: 'Signup',
        pathMatch: 'full'
      },
      {
        path:'traveler-signup',
        component: AdminSignupComponent
      },
      {
        path: 'generateToken',
        component: GenerateTokenComponent
      },
      {
        path:'dependent-onboard',
        component:DependentOnboardComponent
      },
      {
        path: 'generateDependentToken',
        component: DependentTokenComponent
      },
      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistrationRoutingModule { }